import { useFilterRatePerPaxContext } from "./filter-rate-per-pax.context";

export function FilterRatePerPax() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterRatePerPaxContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}